import React, { useState, useEffect } from 'react';
import Marquee from "react-fast-marquee";
import * as nativeEvents from '../../Helper/native';
import { BsShareFill } from "react-icons/bs";
import { BiSolidTimeFive } from "react-icons/bi";

const initiaData = require('../urlEncodeTest.json');
const IplHeader = () => {
    const targetDate = new Date('2026-05-31T23:59:59');
    const [remainingTime, setRemainingTime] = useState(calculateRemainingTime());
    const [showTimer, setShowTimer] = useState(false);

    useEffect(() => {
        // Update remaining time every second
        const timer = setInterval(() => {
            const updatedRemainingTime = calculateRemainingTime();
            setRemainingTime(updatedRemainingTime);
            if (updatedRemainingTime.days <= 2 && !showTimer) {
                setShowTimer(true);
            }
        }, 1000);
        
        // Clear the interval when the component unmounts
        return () => clearInterval(timer);
    }, []);

    function calculateRemainingTime() {
        const now = new Date();
        const difference = targetDate - now;
        // Check if the target time has already passed
        if (difference < 0) {
            return 0;
        }
        // Convert the difference to hours, minutes, and seconds
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        return { hours, minutes, seconds, days };
    }

    const shareWithFriends = () => {
        // APIHelper.postAnalytics("share_from_home");
        nativeEvents.shareWithFriends(initiaData.floatingShareMsg.msg);
    }

    return (
        <div style={{ overflow: 'hidden' }}>
            <div className='headder'>
                <div className='headderMarquee'>
                    <div className='rightLayout'>
                    </div>
                    <div className='leftLayout'>
                    </div>
                    <Marquee speed={30} gradientColor='none' direction='left'>
                        <div className='wazirxHeadderTimerTitle'>
                            Bitcoin Premier League is ending soon! &nbsp;&nbsp;
                        </div>
                    </Marquee>
                    <div className='campTimerContainer' style={{ width: "130px", marginLeft: '0px' }}>
                        <BiSolidTimeFive size={16} color='#FFFFFF' style={{marginTop: '4px'}}/>
                        <div className='timeCounter'>
                            {remainingTime === 0 ? (
                                '00:00:00'
                            ) : (
                                <div style={{ display: 'flex', gap: '2px' }}>
                                    {remainingTime?.days > 2 ? `${remainingTime?.days} days left` : `${String(remainingTime.days * 24 + remainingTime.hours).padStart(2, '0')}:${String(remainingTime.minutes).padStart(2, '0')}:${String(remainingTime.seconds).padStart(2, '0')}`}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className='headerBgColor'>
                    <div className='headerBgColorOverlay'>
                    </div>
                    <div className='headerImgContainerOne'>
                        {/* <div className='headerCta'>
                            <button className="shareCta" onClick={() => shareWithFriends(initiaData.floatingShareMsg.msg)}>
                                <BsShareFill size={22} color='#FFFFFF' />
                            </button>
                        </div> */}
                        <div className='headerTitleContainer'>
                            <div className='head-title'>Bitcoin Premier League</div>
                            <div className='head-subtitle'>Predict. Spend. Stack</div>
                            <div className='head-subtitle-two'>Win Big.</div>
                            <div className='headerImgContainerTwo'>
                                <img src='https://assets.gosats.io/notification/2026/3/1773398574010' alt='headerBgColorOverlay' className='headerBgColorOverlayImg' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default IplHeader;